/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { 
	selectSelectedOwners, 
	selectSelectedCustomers,
	selectSelectedParentTypeKeys,
	selectSelectedParentNames,
	selectSelectedSurveyTypes,
} from './selectors';

const {
	clear,

	clearCustomers,
	addCustomer,
	removeCustomer,

	clearOwners,
	addOwner,
	removeOwner,

	clearParentTypeKeys,
	addParentTypeKey,
	removeParentTypeKey,

	clearParentNames,
	addParentName,
	removeParentName,

	clearSurveyTypes,
	addSurveyType,
	removeSurveyType,
} = createActions(
	{
		CLEAR: () => ({}),

		CLEAR_CUSTOMERS: () => ({}),
		ADD_CUSTOMER: (customer) => ({ customer }),
		REMOVE_CUSTOMER: (customer) => ({ customer }),

		CLEAR_OWNERS: () => ({}),
		ADD_OWNER: (owner) => ({ owner }),
		REMOVE_OWNER: (owner) => ({ owner }),

		CLEAR_PARENT_TYPE_KEYS: () => ({}),
		ADD_PARENT_TYPE_KEY: (parentTypeKey) => ({ parentTypeKey }),
		REMOVE_PARENT_TYPE_KEY: (parentTypeKey) => ({ parentTypeKey }),

		CLEAR_PARENT_NAMES: () => ({}),
		ADD_PARENT_NAME: (name) => ({ name }),
		REMOVE_PARENT_NAME: (name) => ({ name }),

		CLEAR_SURVEY_TYPES: () => ({}),
		ADD_SURVEY_TYPE: (surveyType) => ({ surveyType }),
		REMOVE_SURVEY_TYPE: (surveyType) => ({ surveyType }),
	},
	{ prefix: 'DITActionPlanClosures.filters' }
);

const thunkToggleCustomer = (customer) => (dispatch, getState) => {
	const selectedCustomers = selectSelectedCustomers(getState());
	if (selectedCustomers[customer]) {
		dispatch(removeCustomer(customer));
	} else {
		dispatch(addCustomer(customer));
	}
}

const thunkToggleOwner = (owner) => (dispatch, getState) => {
	const selectedOwners = selectSelectedOwners(getState());
	if (selectedOwners[owner?.compositeId]) {
		dispatch(removeOwner(owner));
	} else {
		dispatch(addOwner(owner));
	}
}

const thunkToggleParentTypeKey = (parentTypeKey) => (dispatch, getState) => {
	const selectedParentTypeKeys = selectSelectedParentTypeKeys(getState());
	if (selectedParentTypeKeys[parentTypeKey]) {
		dispatch(removeParentTypeKey(parentTypeKey));
	} else {
		dispatch(addParentTypeKey(parentTypeKey));
	}
}

const thunkToggleParentName = (parentName) => (dispatch, getState) => {
	const selectedParentNames = selectSelectedParentNames(getState());
	if (selectedParentNames[parentName]) {
		dispatch(removeParentName(parentName));
	} else {
		dispatch(addParentName(parentName));
	}
}

const thunkToggleSurveyType = (surveyType) => (dispatch, getState) => {
	const selectedSurveyTypes = selectSelectedSurveyTypes(getState());
	if (selectedSurveyTypes[surveyType]) {
		dispatch(removeSurveyType(surveyType));
	} else {
		dispatch(addSurveyType(surveyType));
	}
}

export {
	clear,

	clearCustomers,
	addCustomer,
	removeCustomer,

	clearOwners,
	addOwner,
	removeOwner,

	clearParentTypeKeys,
	addParentTypeKey,
	removeParentTypeKey,

	clearParentNames,
	addParentName,
	removeParentName,

	clearSurveyTypes,
	addSurveyType,
	removeSurveyType,

	thunkToggleCustomer,
	thunkToggleOwner,
	thunkToggleParentTypeKey,
	thunkToggleParentName,
	thunkToggleSurveyType,
};
